<div class="engine-wrapper"
    observeIntersection
    [intersectionSteps]='100'
    (onAppearing)="startEngine($event)"
    (didDisappear)="pauseEngine()">
    <canvas #rendererCanvas id="renderCanvas"></canvas>
</div>  